import React from 'react'
import styled from 'styled-components';
import Links from "../constants/links"

const Sidebar = ({ toggleSidebar, isOpen }) => {
    return (
      <Wrapper show={isOpen}>
        <div className="white"/>
        <div div className="black">
          <Links styleClass={`${isOpen ? "sidebar-links" : ""}`} />
          <button className="btn btn-main">Hire Us</button>
        </div>
      </Wrapper>
    )
}

const Wrapper = styled.aside`
  display: flex;  
  opacity: ${props => (props.show ? 1 : 0)};
  position: fixed;
  top: 50px;
  @media screen and (min-width: 768px) { top: 100px;}
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  transition: var(--transition);
  transform: ${props => (props.show ? "translateX(0)" : "translateX(-100%)")};

  .white {
    width: 20vw;
    background: rgba(254, 254, 254, 0.4);
    backdrop-filter: blur(10px);
    @media screen and (min-width: 768px) { width: 80%;}
  }
  
  .black {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 138px 40px;
    width: 80vw;
    background: rgba(18, 18, 18, 0.97);
    @media screen and (min-width: 768px) { width: 20%;}
    .btn {      
      font-size: 14px;
      width: 100%;
      
    }
  }

/*
====================
sidebar-links
====================
*/
.sidebar-links li {
    opacity: 0;
  }
  .sidebar-links li a {
    
    display: block;
    text-align: right;
    text-transform: uppercase;
    color: var(--clr-white);
    letter-spacing: var(--spacing);
    margin-bottom: 0.5rem;    
    font-size: 24px;
    
    line-height: 2.5rem;
    transition: var(--transition);
    border-radius: var(--radius);
    @media screen and (min-width: 768px) {
      font-size: 32px;
      line-height: 4.5rem;
    }
  }
  .sidebar-links li a:hover {
    background: var(--clr-primary-9);
    color: var(--clr-primary-5);
  }

/*
=============== 
Sidebar Animation
===============
*/
.sidebar-links li {
    animation: slideRight 0.5s ease-in-out 0.3s forwards;
  }
  .sidebar-links li:nth-of-type(1) {
    animation-delay: 0.25s;
  }
  .sidebar-links li:nth-of-type(2) {
    animation-delay: 0.5s;
  }
  .sidebar-links li:nth-of-type(3) {
    animation-delay: 0.75s;
  }
  .sidebar-links li:nth-of-type(4) {
    animation-delay: 1s;
  }
  .sidebar-links li:nth-of-type(5) {
    animation-delay: 1.25s;
  }
  @keyframes slideRight {
    0% {
      transform: translateX(-200px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  .sidebar-icons li {
    opacity: 0;
    animation: slideUp 0.5s ease-in-out 0.3s forwards;
  }
  .sidebar-icons li:nth-of-type(1) {
    animation-delay: 0.25s;
  }
  .sidebar-icons li:nth-of-type(2) {
    animation-delay: 0.5s;
  }
  .sidebar-icons li:nth-of-type(3) {
    animation-delay: 0.75s;
  }
  .sidebar-icons li:nth-of-type(4) {
    animation-delay: 1s;
  }
  .sidebar-icons li:nth-of-type(5) {
    animation-delay: 1.25s;
  }
  @keyframes slideUp {
    0% {
      transform: translateY(200px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

`;

export default Sidebar
